import React, { FC } from 'react';

import searchIcon from 'assets/images/svg/search.svg';

import { Image } from '../../../../common';

import './ProjectSearchField.scoped.scss';

interface Props {
  value: string;
  onChange: (value: string) => void;
  onSubmit?: () => void;
  placeholder?: string;
}

const safeDecode = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

const ProjectSearchField: FC<Props> = ({
  value,
  onChange,
  onSubmit,
  placeholder = 'Название или номер проекта',
}) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') {
      onSubmit?.();
    }
  };

  return (
    <div className="project-search-field">
      <Image src={searchIcon} alt="" className="project-search-field__icon" />
      <input
        type="search"
        className="project-search-field__input"
        value={safeDecode(value)}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={handleKeyDown}
      />
      {value !== '' && (
        <button
          type="button"
          className="project-search-field__clear"
          onClick={() => onChange('')}
          aria-label="Очистить поиск"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default ProjectSearchField;
